import { render, staticRenderFns } from "./StudentDetails.vue?vue&type=template&id=10f4004e&"
import script from "./StudentDetails.vue?vue&type=script&lang=ts&"
export * from "./StudentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports